import { Theme } from '@mui/material';

export const radioStyles = (theme: Theme) => ({
  MuiRadio: {
    styleOverrides: {
      root: {
        color: theme.palette.text.primary,
        fill: theme.palette.text.primary,
        zIndex: 0,

        '&.Mui-checked': {
          color: theme.palette.text.primary, // Checked color
        },
        '& .MuiRadio-input': {
          zIndex: 0, // Ensures input doesn't overlap other elements
          position: 'relative', // Override absolute positioning if needed
        },
      },
      sizeSmall: {
        height: '12px',
        width: '12px',
        padding: 0,
      },
    },
  },
});
